import { useQuery } from '@apollo/client';
import { LoadingOrError } from '@retainerclub/common';
import { GET_COMBINED_TRANSACTIONS } from '@retainerclub/customer-api';
import { CustomerCard } from '@retainerclub/customer-shared';
import { useAuth } from '@retainerclub/hooks';
import { useState } from 'react';
import DashboardTransactionsTable from './DashboardTrandsactionsTable';

function DashboardTransactions() {
  const [transactions, setTransactions] = useState([]);
  const { currentUser } = useAuth();

  const { loading, error } = useQuery(GET_COMBINED_TRANSACTIONS, {
    skip: currentUser === null || currentUser === undefined,
    onCompleted: (data) => {
      if (data?.combinedTransactions) {
        const { orderTransactions, subscriptionTransactions } =
          data.combinedTransactions;

        const transactions = [
          ...orderTransactions,
          ...subscriptionTransactions,
        ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setTransactions(transactions);
      }
    },
  });

  const shouldRender = LoadingOrError({
    loading,
    error,
    title: 'Transactions',
  });

  if (shouldRender) {
    return (
      <CustomerCard
        title="Transactions"
        description="Your recent transactions."
      >
        <DashboardTransactionsTable transactions={transactions} />
      </CustomerCard>
    );
  }

  return shouldRender;
}

export default DashboardTransactions;
